import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    apiUrl : process.env.VUE_APP_API_URL || "https://api.safegrp.com/api",
    assetsUrl : process.env.VUE_APP_ASSETS_URL || "https://api.safegrp.com/",
    // apiUrl : "http://localhost:8080/api",
    // assetsUrl : "http://localhost:8080/",
    notice : {
      msg : null,
      error : false
    },
    // logged user and their permissions (loaded from GET /auth/me)
    user : null,
    userLoadedAt : 0
  },
  getters : {
    can : (state) => (permission) => !!state.user && state.user.permissions.includes(permission)
  },
  mutations: {
    closeNotice(state) {
      state.notice.msg = null;
      state.notice.error = null;
    },
    setNotice(state, notice) {
      state.notice.msg = notice.msg;
      state.notice.error = notice.error;
    },
    setUser(state, user) {
      state.user = user;
      state.userLoadedAt = user ? Date.now() : 0;
    }
  },
  actions: {
    // Reads the user and their rights from the API. Returns false when the session is not valid.
    async loadMe({ state, commit }) {
      try {
        const res = await axios.get(`${state.apiUrl}/auth/me`, {
          validateStatus: () => true,
          headers : { 'x-access-token' : localStorage._safeToken }
        });
        if(res.status == 200) {
          commit('setUser', res.data);
          return true;
        }
        if(res.status == 401 || res.status == 403) {
          commit('setUser', null);
          return false;
        }
      } catch (e) {
        // API unreachable: keep the previous rights if any (the API checks them anyway)
        return !!state.user;
      }
      return !!state.user;
    }
  },
  modules: {
  }
})
